import { render, staticRenderFns } from "./UsersPrivilegeEmployeeWorkSchedule.vue?vue&type=template&id=2f3e84d6&scoped=true&"
import script from "./UsersPrivilegeEmployeeWorkSchedule.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployeeWorkSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e84d6",
  null
  
)

export default component.exports